import styled from 'styled-components';

export const BreadcrumbsContainer = styled.div`
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 60px;
    height: 100%;
    pointer-events: none;
    background: linear-gradient(
      to right,
      transparent,
      ${({ theme }) => theme.palette.background}
    );
  }
`;

export const BreadcrumbsWrapper = styled.ul`
  margin: 15px 10px;
  font-family: Roboto, Helvetica, sans-serif;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  overflow-x: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  position: relative;

  &::-webkit-scrollbar {
    display: none;
  }

  @media ${({ theme }) => theme.media.tablet} {
    margin: 20px 0;
  }

  a:first-child {
    padding-left: 0;

    div {
      display: none;
    }
  }

  a {
    color: ${({ theme }) => theme.palette.dark};

    :hover {
      color: ${({ theme }) => theme.palette.primary};
    }
  }
`;

export const Breadcrumb = styled.li`
  padding: 0 8px;
  font-size: 13px;
  display: inline-flex;
  align-items: center;
  position: relative;

  &:last-child {
    padding-top: 2px;
  }

  div {
    position: absolute;
    content: '';
    border: 1px solid ${({ theme }) => theme.palette.dark};
    border-top: none;
    border-left: none;
    width: 4px;
    height: 4px;
    left: -2px;
    top: 48%;
    transform: rotate(-45deg) translateY(-50%);
  }
`;
